import CommonIcon from "@/components/common-icon";
import { showTitle } from "@/libs/util";
export default {
  components: {
    CommonIcon
  },
  methods: {
    showTitle(item) {
      // console.log(item, 9);
      return showTitle(item, this);
    },
    closeMenu() {
      console.log("点击");
    },
    showChildren(item) {
      // if (!item.children) return false;
      // else if (item.children.length <= 1) return false;
      // else if (item.meta && item.meta.showAlways) return true;
      // let hiddenCount = 0; // 对应router.js的sideMenuItemHidden计算是否有需要隐藏的item
      // item.children.forEach(routerItem => {
      //   if (routerItem.meta && routerItem.meta.sideMenuItemHidden) hiddenCount += 1;
      // });
      // console.log(hiddenCount)
      // return item.children.length - 1 !== hiddenCount;

      return (
        item.children &&
        (item.children.length > 1 || (item.meta && item.meta.showAlways))
      );
    },
    getNameOrHref(item, children0) {
      // console.log(item, 32);
      // if (item.href) return `isTurnByHref_${item.href}`;
      // else if (children0) {
      //   console.log(item.children[0].nameText, this.$i18n.tc(item.children[0].nameText))
      //   return item.children[0].nameText ? this.$i18n.tc(item.children[0].nameText) : item.children[0].name;
      // }
      // else {
      //   // console.log(item.nameText)
      //   return item.nameText ? this.$i18n.tc(item.nameText) : item.name;
      // }
      return item.href
        ? `isTurnByHref_${item.href}`
        : children0
        ? item.children[0].name
        : item.name;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/main/components/side-menu/mixin.js